import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import M from 'materialize-css';
import './NavbarResponsive.css';

const Navbar = ({ theme, toggleTheme }) => {
  useEffect(() => {
    // Initialize sidenav
    const elems = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elems);
  }, []);

  // Define text color based on theme
  const textColor = theme === 'light' ? '#333' : 'white';

  // Style objects for light/dark mode
  const linkStyle = {
    color: textColor
  };

  const brandStyle = {
    marginRight: '3rem',
    fontSize: '2rem',
    color: textColor
  };

  const iconStyle = {
    color: textColor
  };

  return (
    <>
      <nav>
        <div className="nav-wrapper container" style={{ display: 'flex', alignItems: 'center', position: 'relative', minHeight: '64px', padding: '0 2rem' }}>
          <Link to="/" className="brand-logo" style={{ ...brandStyle, overflow: 'visible', zIndex: 10, position: 'relative', left: '0' }}>
            MakerSpace3D
          </Link>
          <ul className="right hide-on-med-and-down" style={{ display: 'flex', alignItems: 'center', gap: '2.5rem', margin: 0, padding: 0, listStyle: 'none', flex: 1, justifyContent: 'center' }}>
            <li><Link to="/" className="waves-effect" style={linkStyle}>Home</Link></li>
            <li><Link to="/about" className="waves-effect" style={linkStyle}>About</Link></li>
            <li><Link to="/contact" className="waves-effect" style={linkStyle}>Contact</Link></li>
            <li><Link to="/stl-models" className="waves-effect" style={linkStyle}>3D Models</Link></li>
            <li><Link to="/stl-generator" className="waves-effect" style={linkStyle}>STL Generator</Link></li>
          </ul>
          {/* Desktop Theme Switch - Only visible on desktop */}
          <div className="hide-on-med-and-down" style={{ marginLeft: 'auto', marginRight: '1rem', display: 'flex', alignItems: 'center' }}>
            <div className="switch theme-switch">
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: 0 }}>
                <i className="material-icons" style={iconStyle}>wb_sunny</i>
                <input
                  type="checkbox"
                  id="theme-toggle"
                  checked={theme === 'dark'}
                  onChange={toggleTheme}
                />
                <span className="lever"></span>
                <i className="material-icons" style={iconStyle}>brightness_3</i>
              </label>
            </div>
          </div>
          {/* Flex container for burger and theme icon on mobile */}
          <div className="mobile-icons-flex" style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
            <a href="#!" data-target="mobile-nav" className="sidenav-trigger">
              <i className="material-icons" style={iconStyle}>menu</i>
            </a>
            <div className="mobile-theme-toggle">
              {theme === 'light' ? (
                <i
                  className="material-icons"
                  onClick={toggleTheme}
                  style={iconStyle}
                >
                  brightness_3
                </i>
              ) : (
                <i
                  className="material-icons"
                  onClick={toggleTheme}
                  style={iconStyle}
                >
                  wb_sunny
                </i>
              )}
            </div>
          </div>
        </div>
      </nav>

      <ul className="sidenav" id="mobile-nav">
        <li><Link to="/" className="waves-effect" style={linkStyle}>Home</Link></li>
        <li><Link to="/about" className="waves-effect" style={linkStyle}>About</Link></li>
        <li><Link to="/contact" className="waves-effect" style={linkStyle}>Contact</Link></li>
        <li><Link to="/stl-models" className="waves-effect" style={linkStyle}>3D Models</Link></li>
        <li><Link to="/stl-generator" className="waves-effect" style={linkStyle}>STL Generator</Link></li>
      </ul>
    </>
  );
};

export default Navbar;
